import React from 'react';
import { Input, InputProp } from '@lendi-ui/text-input';

import { useNumeral } from '@funnels/hooks';

import { Suffix } from '../../Fields/_common/style';

interface PercentageInputProps extends Omit<InputProp, 'value' | 'onChange'> {
  value?: number;
  onChange: (value?: number) => void;
  className?: string;
}

function PercentageInput(props: PercentageInputProps) {
  const { value, onChange, className, ...otherProps } = props;
  const [formatted, setNumeralValue] = useNumeral(value);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = setNumeralValue(e.target.value);
    onChange(val);
  }

  return (
    <Input
      size="md"
      value={formatted}
      after={<Suffix>%</Suffix>}
      {...otherProps}
      onChange={handleChange}
      className={className}
    />
  );
}

export default PercentageInput;
